import React, { MouseEventHandler } from "react";
import styled from "styled-components";
import { Button, Col, Row, Table as BsTable } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { RUTA_MASCOTAS } from "../../../services/rutas";
import { MascotaResumida as Mascota } from "../../../services/mascotasServicios";
import AddIcon from "@mui/icons-material/Add";

interface MascotaTableProps {
  onAgregarMascotaClick: MouseEventHandler<HTMLButtonElement>;
  mascotas?: Mascota[];
}

function MascotaTable({ onAgregarMascotaClick, mascotas }: MascotaTableProps) {
  if (!mascotas || mascotas.length === 0) {
    return <></>;
  }
  return (
    <>
      <StyledTable responsive hover>
        <thead>
          <tr>
            <StyledColHeader>Nombre</StyledColHeader>
            <StyledColHeader>Raza</StyledColHeader>
            <StyledColHeader>Edad</StyledColHeader>
          </tr>
        </thead>
        <tbody>
          {mascotas.map((_, index) => (
            <TableItem key={_.id} mascota={_} />
          ))}
        </tbody>
      </StyledTable>
      <Row>
        <ButtonsCol className="mt-4 d-flex justify-content-center">
          <Button
            id="buttonEditar"
            type="button"
            variant="secondary"
            onClick={onAgregarMascotaClick}
          >
            <AddIcon sx={{ fontSize: 20 }} /> Agregar Mascota
          </Button>
        </ButtonsCol>
      </Row>
    </>
  );
}

interface TableItemProps {
  mascota: Mascota;
}

function TableItem({ mascota }: TableItemProps) {
  let navigate = useNavigate();

  return (
    <StyledRow
      onClick={() => navigate(`${RUTA_MASCOTAS}/${mascota.id}`, { replace: false })}
    >
      <StyledCell>{mascota.nombre}</StyledCell>
      <StyledCell>{mascota.raza}</StyledCell>
      <StyledCell>{mascota.edad}</StyledCell>
    </StyledRow>
  );
}

const StyledTable = styled(BsTable)``;

const StyledCell = styled("td")``;

const ButtonsCol = styled(Col)`
  gap: 1%;
`;

const StyledColHeader = styled("th")`
  color: ${(props) => props.theme.colors.main};
`;

const StyledRow = styled("tr")`
  cursor: pointer;
`;

export default MascotaTable;
